import React from "react";
// import Reviews from "./Reviews";
import BubbleAvatarReviewPage from "./BubbleAvatarReviewPage";
import QuoteSliderReviewPage from "./QuoteSliderReviewPage";
import GridMinimalReviewPage from "./GridMinimalReviewPage";
import CommentBlockReviewPage from "./CommentBlockReviewPage";
import CardCarouselReviewPage from "./CardCarouselReviewPage";
import { useSelector } from "react-redux";

function ReviewsPageWrapper() {
      const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {/* <Reviews/> */}
      {sitedata?.theme_patient_reviews === "bubble-avatar" ? (
        <BubbleAvatarReviewPage />
      ) : sitedata?.theme_patient_reviews === "card-carousel" ? (
        <CardCarouselReviewPage />
      ) : sitedata?.theme_patient_reviews === "centered-quote-slide" ? (
        <QuoteSliderReviewPage />
      ) : sitedata?.theme_patient_reviews === "grid-minimal" ? (
        <GridMinimalReviewPage />
      ) : (
        <CommentBlockReviewPage />
      )}
    </>
  );
}

export default ReviewsPageWrapper;
